import { useStarRatingCtx } from './starRatingContext';

export const StarRatingLabel = () => {
  const { rating, labelText } = useStarRatingCtx();

  return <div>{labelText(rating)}</div>;
};
